export default __webpack_public_path__ + "static/media/background_register.32fa181c.png";